import { CustomClaimMessages, TranslationCustomClaimMessages } from "../interfaces";

export const messages: TranslationCustomClaimMessages = {
  [CustomClaimMessages.defaultClaims]: "Direito padrão do grupo",
  [CustomClaimMessages.additionalUserClaim]: "Privilégio personalizado",
  [CustomClaimMessages.restrictedUserClaim]: "Revogação personalizada"
};